module.exports = __webpack_public_path__ + "static/media/03.7b1a39e5.svg";